import loadProductModule from './modules/Product.module';
const loadProductContentVideoModule = initialData => ({
    hasRouter: false,
    modules: [loadProductModule(initialData)],
});
export default loadProductContentVideoModule;
